
import { AxiosError, EQLQuery, GeneratedQuery, MapResponseFn } from "@eco/client";
import useEcoClient from "hooks/useEcoClient";
import { useMemo } from "react";
import useEcoQuery, { UseEcoQueryOptions } from "./useEcoQuery";



/**
 * 
 * Custom hook to query Ecomundo EQL API   
 * 
 * @param query object containing eql query
 * @param mapResponseFn mapping function for API response
 * @param config to pass to reactQuery
 * 
 */

export const useEqlQuery = <TData, S extends EQLQuery & GeneratedQuery, R = unknown> (
    query: S,
    mapResponseFn?: MapResponseFn<TData,R>,
    config?: UseEcoQueryOptions<unknown, TData, AxiosError>
) => 
{
    const cacheKey = useMemo(() => [query.cacheKey, query.variables], [query])
    const ecoClient = useEcoClient() ;
    let signedQuery: EQLQuery = {
        ...query,
        config: {},
        signature: undefined,
        parameters: query.variables,
        variables: undefined,
        cacheKey: undefined
    };
    
    if (process.env.REACT_APP_SIGN_QUERY) {
        signedQuery.config!.headers = {
            'Authorization' : `Bearer ${query.signature}`
        }
    }
    
    const queryFn = async () => ecoClient.search<TData,R>(signedQuery, mapResponseFn);
    return useEcoQuery(cacheKey, queryFn, { enabled: query !== undefined, ...config})
}
